import { render, staticRenderFns } from "./BodyTalkLogo.vue?vue&type=template&id=9835f5d4"
import script from "./BodyTalkLogo.vue?vue&type=script&lang=js"
export * from "./BodyTalkLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports